module.exports = __webpack_public_path__ + "static/media/italiano.0787cb0e.png";